import { defineHierarchyChart } from '@rdrive/helper-chart-config';
import { STATUS_HISTORY_CHART, SINGLE_STATUS_LEVEL } from './statusHistoryHierarchy.js';

// Status-history activity by drawing set -> drawing -> location -> status -> single status, for the
// Activity page's StackedHorizontalBarChart (@rdrive/plugin-chart-stacked-bar). Since
// IA_ABSORPTION_PLAN Phase 5 steps 5.2–5.4 a level table on `defineHierarchyChart`
// (@rdrive/helper-chart-config) — the generated queries equal the old hand-written ones
// (tooling/parity/hierarchy-chart/), and every filter value goes through escapeSql (rule 6).
//
// Scoping: none — a status bar's parent id (its location) arrives as the base's second positional
// contextUpdater argument, so no closure drill state is needed (./statusHistoryHierarchy.js).

const LOCATIONS = 'JOIN locations l ON sh.locationId = l.id';
const DRAWINGS = 'JOIN drawings d ON l.drawingId = d.id';

export function useStatusHistoryLocationChart({ chartName, filterContext, conn }) {
  return defineHierarchyChart({
    chartName,
    filterContext,
    conn,
    ...STATUS_HISTORY_CHART,
    levels: [
      {
        level: 'drawingSet', titleKey: 'drawingSets',
        id: 'd.drawingSetId', parentId: 'd.drawingSetId', title: 'd.drawingSetTitle', joins: [LOCATIONS, DRAWINGS],
        orderBy: 'd.drawingSetTitle, sort, s.title',
        filter: { joins: [LOCATIONS, DRAWINGS], where: [['d.drawingSetId', 'id']] },
      },
      {
        level: 'drawing', titleKey: 'drawings',
        id: 'd.id', parentId: 'd.drawingSetId', title: 'd.title', joins: [LOCATIONS, DRAWINGS],
        orderBy: 'd.title, sort, s.title',
        filter: { joins: [LOCATIONS], where: [['l.drawingId', 'id']] },
      },
      {
        level: 'location', titleKey: 'locations',
        id: 'l.id', parentId: 'l.drawingId', title: 'l.title', joins: [LOCATIONS],
        orderBy: 'l.title, sort, s.title',
        filter: { where: [['sh.locationId', 'id']] },
      },
      // Filters by the clicked status AND its location (the positional parent id)
      {
        level: 'status', titleKey: 'status',
        id: 's.id', parentId: 'sh.locationId', title: 's.title',
        groupBy: 's.id, sh.locationId, s.title, s.color, s.sort', orderBy: 's.sort, s.title',
        filter: { where: [['sh.statusId', 'id'], ['sh.locationId', 'parentId']] },
      },
      SINGLE_STATUS_LEVEL,
    ],
  });
}
